// extracted by mini-css-extract-plugin
export default {"headerLeftContainer":"ProductDetails_headerLeftContainer__3+Dvc","dataIcon":"ProductDetails_dataIcon__gpziI"};